import React, { useState, useEffect } from "react";

import { Grid, GridColumn as Column } from "@progress/kendo-react-grid";
import { process, orderBy } from "@progress/kendo-data-query";
import AttestationStatusComp from "./AttestationStatusComp";

const AttestationGrid = (props)=>{

  const initGridSortState = {
      sort: [{ field: "requestDateTime", dir: "desc" }]
    };
    
  const initGridPagingState = {
      take: props.dataFrame.limit,
      skip: props.dataFrame.startIndex,
      pageable: {
        buttonCount: 5,
        info: true,
        type: "numeric",
        pageSizes: true,
        previousNext: true,
      },
  };
    
    
  const [gridSortState, setGridSortState] = useState(initGridSortState);
  const [gridPagingState, setGridPagingState] = useState(initGridPagingState);
  
  const onGridSortStateChange = (e) => {
      setGridSortState({
        ...gridSortState,
        sort: e.sort,
      });
  };
      
  const onGridPagingStateChange = (e) => {
      props.setDataFrame(p => { return { ...p, startIndex: e.page.skip, limit: e.page.take } })
  };
  
  useEffect(() => {
      setGridPagingState({
        ...gridPagingState,
        skip: props.dataFrame.startIndex,
        take: props.dataFrame.limit,
      });
  }, [props.dataFrame]);

  
  const handleRowClick = (e) => {
      props.onDetail(e.dataItem.id);
  };

  const statusCell = (cellProps) => {
      return (
        <td onClick={() => handleRowClick(cellProps.dataItem)}>
          <AttestationStatusComp status={cellProps.dataItem.status}>{cellProps.dataItem.statusLabel}</AttestationStatusComp>
        </td>
      );
  };

  const sentTimestampCell = (props) => {
    return (<td>{props.dataItem.sentTimestamp} </td>);
  };

  const getAttestations = (sort) => {
    let items = props.items.map(x => (
      { ...x,
        requestDateTime: new Date(x.sentTimestamp)
      })
    );
    return orderBy(items, sort);
  };
      
    return (

        <Grid
            sortable
            sort={gridSortState.sort}
            onSortChange={onGridSortStateChange}
            data={getAttestations(gridSortState.sort).slice(
                gridPagingState.skip,
                gridPagingState.take + gridPagingState.skip
            )}
            resizable
            skip={gridPagingState.skip}
            take={gridPagingState.take}
            total={props.items.length}
            pageable={gridPagingState.pageable}
            onPageChange={onGridPagingStateChange}
            reorderable
            onRowClick={handleRowClick}
            >
            <Column field="attestationTitle" width="400px" title="Attestation Title" />
            <Column field="requestDateTime" width="200px" title="Sent Date" cell={sentTimestampCell} />
            <Column field="description" title="Description" />
            <Column field="status" width="160px" title="Attestation Status" 
              cell={statusCell}
            />
        </Grid>

    );


};


export default AttestationGrid;